var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Creative',{attrs:{"id":_vm.getCreativeId,"title":`Creative Details`}})
}
var staticRenderFns = []

export { render, staticRenderFns }